module.exports = __webpack_public_path__ + "static/media/vision.5d8a1a81.svg";